import React, { useEffect, useState } from 'react';
import { apiFetch } from '../utils/api'; // Adjust the path as needed
import LoadingSpinner from '../Components/LoadingSpinner';

function AdminAccessPanel() {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  

  // Fetch all access requests
  const fetchRequests = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await apiFetch('getAccessRequests');
      
      if (data.success) {
        setRequests(data.requests || []);
      } else {
        setError(data.message || 'Failed to fetch requests.');
      }
    } catch (err) {
      setError(err.message || 'Unexpected error occurred.');
    } finally {
      setLoading(false);
    }
  };

  // Update the status of a specific request
  const updateStatus = async (id, status) => {
    try {
      const result = await apiFetch('updateAccessRequest', {
        method: 'POST',
        body: JSON.stringify({ id, status }),
      });

      if (result.success) {
        // If approved, remove from the visible list; otherwise update status
        setRequests((prev) => {
          if (status === 'approved') {
            return prev.filter((r) => r.id !== id);
          }
          return prev.map((r) => (r.id === id ? { ...r, status } : r));
        });
      } else {
        alert(`Failed to update status: ${result.message}`);
      }
    } catch (err) {
      console.error('Error updating status:', err);
      alert('Error updating request.');
    }
  };

  useEffect(() => {
    fetchRequests();
  }, []);

  if (loading) return <LoadingSpinner message="Loading requests…" />;
  if (error) return <p className="text-danger">{error}</p>;

  return (
    <div className="container mt-3">
      <h2 className="mb-3">Access Requests</h2>
      {requests.filter((r) => String(r.status).toLowerCase() !== 'approved').length === 0 ? (
        <p>No requests found.</p>
      ) : (
        requests
          .filter((req) => String(req.status).toLowerCase() !== 'approved')
          .map((req) => (
          <div key={req.id} className="card mb-2 p-2">
            <p>
              <strong>{req.full_name}</strong> ({req.email})
            </p>
            <p>
              <strong>Brokerage</strong> ({req.brokerage})
            </p>
            <p>{req.message}</p>
            <div className="d-flex gap-2">
              <button
                className="btn btn-success btn-sm"
                onClick={() => updateStatus(req.id, 'approved')}
              >
                Approve
              </button>
              <button
                className="btn btn-danger btn-sm"
                onClick={() => updateStatus(req.id, 'rejected')}
              >
                Reject
              </button>
            </div>
            <p className="mt-2">
              <strong>Status:</strong> {req.status}
            </p>
          </div>
        ))
      )}
    </div>
  );
}

export default AdminAccessPanel;
